module.exports = __webpack_public_path__ + "img/Eswatini.48df7b98.svg";